import { Activity, CreateUser, Login, SearchActivity, User } from "./Models";

export const Builders = {
    buildLogin: (user, password) => {
        return new Login(user, password);
    },
    buildUser: (idUsr, name, lastname, phone, email, idUsrService) => {
        return new User(idUsr, name, lastname, phone, email, idUsrService);
    },
    buildActivity: (amount, sourceSearch, description, code, email, idUsr) => {
        let activity = new Activity();
        activity.amount = amount;
        activity.sourceSearch = sourceSearch;
        activity.description = description;
        activity.code = code;
        activity.type = 'PAY';
        activity.email = email;
        activity.idUsr = idUsr;
        activity.discount = 0;
        return activity;
    },
    buildSearchActivity: (amount, idUsrService, description) => {
        let searchActivity = new SearchActivity();
        searchActivity.type = 'SERVICE';
        searchActivity.idSearch = idUsrService;
        searchActivity.amount = amount;
        searchActivity.discount = 0;
        searchActivity.taxes = 0;
        searchActivity.description = description;
        searchActivity.others = {
            txChannel: 'CF'
        };
        return searchActivity;
    },
    buildCreateUserPayload: (email, name, lastname, phone) => {
        let createUser = new CreateUser();
        createUser.email = email;
        createUser.name = name;
        createUser.lastname = lastname;
        createUser.phone = phone || "";

        return createUser;
    },
};

export default Builders;
